<template>
  <div class="rank">
    <div class="title">
      <span>排名</span>
      <span>奋斗者</span>
      <span>票数</span>
    </div>

    <div class="list">
      <div class="item" v-for="(item, index) in rankList" :key="index">
        <div class="index">{{ index + 1 }}</div>
        <div class="middle">
          <div class="avatar"><img :src="item.url" alt="" /></div>
          <div class="info">
            <div class="name">{{ item.title }}</div>
            <div class="desc">{{ item.identity }}</div>
          </div>
        </div>
        <div class="vote">{{ item.votes }}票</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rankList: [],
  },
  data() {
    return {};
  },

  created() {},
};
</script>
<style lang="less" scoped>
.rank {
  width: 100%;
  height: 100%;

  .title {
    border-bottom: 1px solid #f2f2f2;
    display: flex;

    span {
      flex: 1;
      text-align: center;
    }
  }

  .list {
    width: 100%;

    padding: 10px;
    .item {
      padding: 10px;
      display: flex;
      align-items: center;
      .index {
        width: 30px;

        margin-right: 10px;
      }

      .middle {
        // width: 80%;
        display: flex;
        align-items: center;

        .avatar {
          width: 40px;
          height: 50px;

          margin-right: 20px;
          img {
            width: 100%;
            height: 100%;
          }
        }

        .info {
          .name {
            font-weight: bold;
          }
        }

        .desc {
          width: 160px;
          margin-right: 20px;
          font-size: 12px;
        }
      }

      .vote {
        width: 140px;
        text-align: right;
      }
    }
  }
}
</style>
